export { default } from "bullitttime-embermodelsevent/adapters/penalty-timing-record";
